export default __webpack_public_path__ + "images/resizeBlack.6ab50722318e5cde8b15537bbf05003a.svg";